import $ from 'jquery';

$.addInit(function(context) {
	var base = '.b-form';
	$(base, context).validity({
		errors: {
			typeMismatch: 'Некорректное значение',
			valueMissing: 'Заполните поле'
		},
		unknownError: 'Неизвестная ошибка',
		output: function(input, message) {
			var field = $(input).not('button, [type=submit]').closest(base + '-field');
			field.toggleClass('m-error', !!message);
			field.find('.i-form-checkbox').toggleClass('m-error', !!message);
			field.find(base + '-error').text(message);
		}
	});

	var input = $(base).find(base + '-input');

	// https://materializecss.com/text-inputs.html
	function labelEffects(input) {
		if (!String.prototype.trim) {
			(function() {
				var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
				String.prototype.trim = function() {
					return this.replace(rtrim, '');
				};
			})();
		}

		[].slice.call(input).forEach(function(inputEl) {
			if( inputEl.value.trim() !== '' ) {
				$(inputEl.parentNode).addClass('m-active');
			}

			inputEl.addEventListener('focus', onInputFocus);
			inputEl.addEventListener('blur', onInputBlur);
		} );

		function onInputFocus(e) {
			$(e.target.parentNode).addClass('m-active');
		}

		function onInputBlur(e) {
			if( e.target.value.trim() === '' ) {
				$(e.target.parentNode).removeClass('m-active');
			}
		}
	}

	labelEffects(input);
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-form.js
// module id = 38
// module chunks = 0